import React from 'react';
import { View, StyleSheet, TextInput } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import EStyleSheet from 'react-native-extended-stylesheet';

export default function ReportedUsernameInputField({ leftIcon, ...otherProps }) {
  return (
    <View style={styles.container}>
      {leftIcon && (
        <MaterialCommunityIcons
          name={leftIcon}
          size={20}
          color='#6e6869'
          style={styles.icon}
        />
      )}
      <TextInput
        style={styles.input}
        placeholderTextColor='#6e6869'
        {...otherProps}
      />
    </View>
  );
}
const styles = EStyleSheet.create({
  container: {
    backgroundColor: '#f9f9f9',
    borderRadius: 25,
    flexDirection: 'row',
    padding: '.9rem',
    marginVertical: '.25rem',
  },
  icon: {
    marginRight: 10
  },

  input: {
    width: '17rem',
    height: '1rem',
    fontSize: '1rem',
    color: '#101010',
    borderRadius: 25,
    padding: '.9rem'
  }
});